import React, { Component } from 'react';

import Page from '../containers/page';
import Isvg from "react-inlinesvg";
import 'react-circular-progressbar/dist/styles.css';
import { API_ENDPOINT } from "../constants";
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import CuroflowIcon from "../assets/images/Curoflow_Digital_Telemedicine_Platform_Icon.png"
import SupportForm11 from '../components/forms/supportForm11';
import SupportForm12 from '../components/forms/supportForm12';
import SupportForm13 from '../components/forms/supportForm13';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Marquee from "react-fast-marquee";
import Img from '../components/Img';
import { Waypoint } from 'react-waypoint';

import AppImg from "../assets/images/appImg.png"
import ContactForm from '../components/forms/contactForm';
import AOS from 'aos';
import 'aos/dist/aos.css'


var striptags = require('striptags');

function parseJSON(response) {
    return response.json().then((json) => {
        return {
            result: json,
            status: response.status,
        };
    });
}

class WeAssist extends Component {
    constructor(props) {
        super(props);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.player = React.createRef();

        this.state = {
            promotedProjects: [],
            poolActive: false,
            chatForm: false,
            yScroll2: 0,
            ourSolutions: [],
            solutionsStatus: false,
            ...props.initialData,
            _first: 0,
            _second: 0,
            _third: 0,
            supportForm11: false,
            supportForm12: false,
            supportForm13: false,

        };
    }

    listenToScroll = () => {
        const yScroll2 =
            document.body.scrollTop || document.documentElement.scrollTop


        this.setState({
            yScroll2: yScroll2,
        })
    }

    sendMessage1 = (data) => {
        if (data.checked) {
            data.lang = this.props.lang
            this.setState({
                loading1: true
            }, () => {

                fetch(API_ENDPOINT + '/data/contact/new', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ data })
                }).then(parseJSON).then(({ result, status }) => {
                    if (result.error) {
                        this.setState({ error: result.error })
                    } else {
                    }
                })
            })
        }
    }

    sendMessage82 = (data) => {
        this.props.setRecaptchaCallback(() => {

            if (data && data.checked && this.props.allowSubmit) {
                console.log('bbbbbbbbbbbbbbbb', this.state.pageData);
                console.log('bbbbbbbbbb', data);


                // if (data.email && (data.email.toLowerCase().indexOf('@gmail.com') !== -1 || data.email.toLowerCase().indexOf('@live.com') !== -1 || data.email.toLowerCase().indexOf('@mailinator.com') !== -1 || data.email.toLowerCase().indexOf('@jollyfree.com') !== -1 || data.email.toLowerCase().indexOf('@gotgel.org') !== -1 || data.email.toLowerCase().indexOf('@yahoo.com') !== -1 || data.email.toLowerCase().indexOf('@hotmail.com') !== -1)) {
                //     return this.setState({ contactFormError2: 'Please fill in your work email' })
                // } else this.setState({ contactFormError2: null })
                if (data.email && (data.email.toLowerCase().indexOf('@gmail.com') !== -1 || data.email.toLowerCase().indexOf('@live.com') !== -1 || data.email.toLowerCase().indexOf('@mailinator.com') !== -1 || data.email.toLowerCase().indexOf('@jollyfree.com') !== -1 || data.email.toLowerCase().indexOf('@gotgel.org') !== -1 || data.email.toLowerCase().indexOf('@yahoo.com') !== -1 || data.email.toLowerCase().indexOf('@hotmail.com') !== -1 || data.email.toLowerCase().indexOf('@business.com') !== -1 || data.email.toLowerCase().indexOf('@admin.com') !== -1 || data.email.toLowerCase().indexOf('@info.com') !== -1)) {
                    return this.setState({ contactFormError3: 'Please fill in your work email' })
                } else this.setState({ contactFormError3: null })

                // if (data.message?.length < 25) return this.setState({ contactFormMessageError3: 'Please use at least 25 letters' });
                // else this.setState({ contactFormMessageError3: null })


                data.lang = this.props.lang
                data.url = typeof window !== 'undefined' ? window.location?.pathname : 'No Data';
                data.bookADemo = true
                data.page = this.props.lang === "en" ? this.state.pageData?.name?.en : this.state.pageData?.name?.se
                data.token = this.props.recaptchaToken
                data.isMobile = this.props.isMobile
                data.osMobileNameUA = this.props.osMobileNameUA
                data.browserName = this.props.browserName,
                    data.browserNameUA = this.props.browserNameUA

                console.log('data', data)

                this.setState({
                    loading2: true
                }, () => {

                    fetch(API_ENDPOINT + '/data/contact/new', {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({ data })
                    }).then(parseJSON).then(({ result, status }) => {
                        if (result.error) {
                            this.setState({ error: result.error })
                        } else {
                            this.setState({
                                supportForm: false
                            }, () => {
                                const path = 'thank-you';
                                this.props[0].history.push(`/${path}`);
                            })

                        }
                    })

                })
            }
        })
        this.props.updateToken();

    }


    sendMessage2 = (data) => {
        this.props.setRecaptchaCallback(() => {
            if (data && data.checked && this.props.allowSubmit) {
                if (data.email && (data.email.toLowerCase().indexOf('@gmail.com') !== -1 || data.email.toLowerCase().indexOf('@live.com') !== -1 || data.email.toLowerCase().indexOf('@mailinator.com') !== -1 || data.email.toLowerCase().indexOf('@jollyfree.com') !== -1 || data.email.toLowerCase().indexOf('@gotgel.org') !== -1 || data.email.toLowerCase().indexOf('@yahoo.com') !== -1 || data.email.toLowerCase().indexOf('@hotmail.com') !== -1 || data.email.toLowerCase().indexOf('@business.com') !== -1 || data.email.toLowerCase().indexOf('@admin.com') !== -1 || data.email.toLowerCase().indexOf('@info.com') !== -1)) {
                    return this.setState({ contactFormError: 'Please fill in your work email' })
                } else this.setState({ contactFormError: null })


                // if (data.message?.length < 25) return this.setState({ contactFormMessageError: 'Please use at least 25 letters' });
                //     else this.setState({ contactFormMessageError: null })

                data.lang = this.props.lang
                data.url = typeof window !== 'undefined' ? window.location?.pathname : 'No Data';
                data.bookADemo = false;
                data.page = this.props?.[0]?.match?.params?.alias?.replace(/-/g, ' ') || 'No Data';
                data.token = this.props.recaptchaToken
                data.isMobile = this.props.isMobile
                data.osMobileNameUA = this.props.osMobileNameUA
                data.browserName = this.props.browserName,
                    data.browserNameUA = this.props.browserNameUA
                this.setState({
                    loading2: true
                }, () => {

                    setTimeout(() => {
                        this.player?.current?.pause()
                    }, 1120)

                    fetch(API_ENDPOINT + '/data/contact/new', {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({ data })
                    }).then(parseJSON).then(({ result, status }) => {
                        if (status === 429) {
                            this.setState({
                                solutionsStatus: true,
                                loading2: false
                            })
                        }
                        if (result.error) {
                            this.setState({ error: result.error })
                        } else {
                            this.props.bookDemo(false)
                            const path = 'thank-you';
                            this.props[0].history.push(`/${path}`);

                        }
                    })
                })
            }
        })
        this.props.updateToken();

    }





    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {

                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        // if (this.props[0].match.params.alias) {
        //     fetch(API_ENDPOINT + '/data/pages/all-weassist', {
        //         method: 'GET',
        //         headers: {
        //             'content-type': 'application/json'
        //         },
        //     }).then(parseJSON).then(({ result, status }) => {

        //         if (result.error) {
        //             this.setState({ error: result.error })
        //         } else {
        //             this.setState({
        //                 pageData: { ...result.filter(page => page.alias && page.alias[this.props.lang] && page.alias[this.props.lang] === ('/' + this.props[0].match.params.alias))[0] }
        //             })
        //         }
        //     })
        // }
    }

    increment = () => {
        let first = 10;


        if (first > this._first) {
            this._first += 1;
            this?.setState?.({ _first: this._first });
        }
        else {
            if (this._first > first) return this.setState({ _first: first })
            return
        }
        // if (second > this.state._second) {
        //     this?.setState?.(prev => ({ ...prev, _second: (prev?._second || 0) + 1 }));


        // }
        // if (third > this.state._third) {
        //     this?.setState?.(prev => ({ ...prev, _third: (prev?._third || 0) + 1 }));




        // }
        setTimeout(() => {
            this.increment()
        }, 60)
    }


    increment1 = () => {
        // let first = 46;
        let second = 40;
        // let third = 271;
        // if (first > this.state._first || second > this.state._second || third > this.state._third) {
        // if (first > this.state._first) {
        //     this?.setState?.(prev => ({ ...prev, _first: (prev?._first || 0) + 1 }));


        // }
        // if (second > this.state._second) {
        //     this?.setState?.(prev => ({ ...prev, _second: prev?._second + 4 }));


        // }
        // // if (third > this.state._third) {
        // //     this?.setState?.(prev => ({ ...prev, _third: (prev?._third || 0) + 1 }));




        // // }
        // else {
        //     if (this.state._second > second) return this.setState({_second: second})
        //     return
        // }

        if (second > this._second) {
            this._second += 4;
            this?.setState?.({ _second: this._second });
        }
        else {
            if (this._second > second) return this.setState({ _second: second })
            return
        }


        setTimeout(() => {
            this.increment1()
        }, 40)


    }


    increment2 = () => {
        // let first = 46;
        // let second = 300;
        let third = 240;
        // if (first > this.state._first || second > this.state._second || third > this.state._third) {
        // if (first > this.state._first) {
        //     this?.setState?.(prev => ({ ...prev, _first: (prev?._first || 0) + 1 }));


        // }
        // if (second > this.state._second) {
        //     this?.setState?.(prev => ({ ...prev, _second: (prev?._second || 0) + 1 }));


        // }
        // if (third > this.state._third) {
        //     this?.setState?.(prev => ({ ...prev, _third: prev?._third + 4 }));
        // }
        // else {
        //     if (this.state._third > third) return this.setState({_third: third})
        //     return
        // }

        if (third > this._third) {
            this._third += 4;
            this?.setState?.({ _third: this._third });
        }
        else {
            if (this._third > third) return this.setState({ _third: third })
            return
        }


        setTimeout(() => {
            this.increment2()
        }, 12)


    }

    componentDidMount() {
        this._first = 0;
        this._second = 0;
        this._third = 0;
        this.get();

        if (this.props[0].location && !this.props[0].location.hash) {
            if (typeof window !== 'undefined') { window.scrollTo(0, 0); }
        } else if (this.props[0].location && this.props[0].location.hash) {
            document.getElementById(this.props[0].location.hash.replace('#', '')).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        this.updateWindowDimensions();
        window.addEventListener('scroll', this.listenToScroll)

        AOS.init({
            duration: 1000
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.pathname != this.props[0].location.pathname) {
            this.get()
        }
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    render() {
        // console.log('TEST: ', this.state.pageData);
        return (
            <div>

                {/*******************  first booka demo on top page we assist *****************/}
                {
                    this.state.supportForm11 ?
                        <div className='overlay overlay-active' onClick={() => {
                            this.setState({
                                supportForm11: false
                            })
                        }}></div>
                        :
                        null
                }

                <div className={this.state.supportForm11 ? 'contact-popup open' : 'contact-popup'}>
                    <span className="close-icon" onClick={() => {
                        this.setState({
                            supportForm11: false
                        })
                    }}>x</span>
                    {
                        !this.state.loading3 && !this.state.supportStatus ?
                            <SupportForm11 onSubmit={this.sendMessage82} lang={this.props.lang} contactFormError={this.state.contactFormError3} contactFormMessageError={this.state.contactFormMessageError3} />
                            : null
                    }
                    {
                        this.state.loading3 ?
                            <Player
                                ref={this.player}
                                autoplay={true}
                                onEvent={(event) => {
                                    if (event == 'complete') {
                                        this.setState({
                                            supportForm11: false,
                                            loading3: false
                                        })
                                    }
                                }}
                                //keepLastFrame={true}
                                //loop={false}
                                controls={true}
                                src="https://assets4.lottiefiles.com/packages/lf20_oaw8d1yt.json"
                                style={{ height: '300px', width: '300px' }}
                            ></Player>
                            :
                            null
                    }
                    {this.state.supportStatus && <h2 className='status-popup support-status'>{'Please, try again later!'.translate(this.props.lang)}</h2>}
                </div>

                {/********  end first booka demo on top page we assist ****************************/}

                {/*******************  second booka demo on packages  page we assist *****************/}
                {
                    this.state.supportForm12 ?
                        <div className='overlay overlay-active' onClick={() => {
                            this.setState({
                                supportForm12: false
                            })
                        }}></div>
                        :
                        null
                }

                <div className={this.state.supportForm12 ? 'contact-popup open' : 'contact-popup'}>
                    <span className="close-icon" onClick={() => {
                        this.setState({
                            supportForm12: false
                        })
                    }}>x</span>
                    {
                        !this.state.loading3 && !this.state.supportStatus ?
                            <SupportForm12 onSubmit={this.sendMessage82} lang={this.props.lang} contactFormError={this.state.contactFormError3} contactFormMessageError={this.state.contactFormMessageError3} />
                            : null
                    }
                    {
                        this.state.loading3 ?
                            <Player
                                ref={this.player}
                                autoplay={true}
                                onEvent={(event) => {
                                    if (event == 'complete') {
                                        this.setState({
                                            supportForm11: false,
                                            loading3: false
                                        })
                                    }
                                }}
                                //keepLastFrame={true}
                                //loop={false}
                                controls={true}
                                src="https://assets4.lottiefiles.com/packages/lf20_oaw8d1yt.json"
                                style={{ height: '300px', width: '300px' }}
                            ></Player>
                            :
                            null
                    }
                    {this.state.supportStatus && <h2 className='status-popup support-status'>{'Please, try again later!'.translate(this.props.lang)}</h2>}
                </div>

                {/********  end second booka demo on packages page we assist ****************************/}




                {/*******************  third booka demo on packages  page we assist *****************/}
                {
                    this.state.supportForm13 ?
                        <div className='overlay overlay-active' onClick={() => {
                            this.setState({
                                supportForm13: false
                            })
                        }}></div>
                        :
                        null
                }

                <div className={this.state.supportForm13 ? 'contact-popup open' : 'contact-popup'}>
                    <span className="close-icon" onClick={() => {
                        this.setState({
                            supportForm13: false
                        })
                    }}>x</span>
                    {
                        !this.state.loading3 && !this.state.supportStatus ?
                            <SupportForm13 onSubmit={this.sendMessage82} lang={this.props.lang} contactFormError={this.state.contactFormError3} contactFormMessageError={this.state.contactFormMessageError3} />
                            : null
                    }
                    {
                        this.state.loading3 ?
                            <Player
                                ref={this.player}
                                autoplay={true}
                                onEvent={(event) => {
                                    if (event == 'complete') {
                                        this.setState({
                                            supportForm13: false,
                                            loading3: false
                                        })
                                    }
                                }}
                                //keepLastFrame={true}
                                //loop={false}
                                controls={true}
                                src="https://assets4.lottiefiles.com/packages/lf20_oaw8d1yt.json"
                                style={{ height: '300px', width: '300px' }}
                            ></Player>
                            :
                            null
                    }
                    {this.state.supportStatus && <h2 className='status-popup support-status'>{'Please, try again later!'.translate(this.props.lang)}</h2>}
                </div>

                {/********  end third booka demo on packages page we assist ****************************/}






                {/* <div className={this.props.openModalBookDemo ? 'contact-popup open' : 'contact-popup'}>
                    <span className="close-icon" onClick={() => {
                        this.props.bookDemo(false)
                    }}>x</span>
                    {
                        !this.state.loading3 && !this.state.supportStatus ?
                            <SupportForm onSubmit={this.sendMessage2} lang={this.props.lang} />
                            : null
                    }
                    {
                        this.state.loading3 ?
                            <Player
                                ref={this.player}
                                autoplay={true}
                                onEvent={(event) => {
                                    if (event == 'complete') {
                                        this.setState({
                                            supportForm: false,
                                            loading3: false
                                        })
                                    }
                                }}
                                //keepLastFrame={true}
                                //loop={false}
                                controls={true}
                                src="https://assets4.lottiefiles.com/packages/lf20_oaw8d1yt.json"
                                style={{ height: '300px', width: '300px' }}
                            ></Player>
                            :
                            null
                    }
                    {this.state.supportStatus && <h2 className='status-popup support-status'>{'Please, try again later!'.translate(this.props.lang)}</h2>}
                </div> */}
                {
                    this.state.pageData ?
                        <div>

                            {
                                this.state.pageData.section1 ?
                                    <section className={`sectionTextBigimg sectionTextBigImgNoBg`}>
                                        <div className="title">
                                            {/* <h1 dangerouslySetInnerHTML={{__html: Object.translate(this.state.pageData && this.state.pageData.section[0], 'title', this.props.lang)}}></h1> */}
                                            <h1>{this.state.pageData && this.state.pageData.section[0] && this.state.pageData.section[0].title[this.props.lang]}</h1>
                                            <div dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData?.section[0] && this.state.pageData.section[0], 'shortDescription', this.props.lang) }}></div>
                                        </div>
                                        <img src={CuroflowIcon} className={`${(this.state.pageData && this.state.pageData.backgroundImagePositionRight) ? 'rightSideWeAssist' : " "} ${(this.state.pageData && this.state.pageData.backgroundImagePositionLeft) ? 'leftSideWeAssist' : " "}`} alt="Curoflow Digital Telemedicine Platform Icon" />
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section2 ?
                                    <section className={`curoflow-section curoflow-margin-bottom c-change ${(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0] && this.state.pageData.section[1].item[0].backgroundDark) ? 'curoflow-bg-dark1' : " "} ${(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0] && this.state.pageData.section[1].item[0].backgroundLightGrey) ? 'curoflow-bg-grey1' : " "}`}>
                                        <div className={`container-curoflow  ${(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].shortDescription && this.state.pageData.section[1].item[1].shortDescription.se) ? 'column-reverse' : "column-reverse"} `}>
                                            <div className="col-curoflow-lg-6 ">
                                                <h2>{this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0]?.title[this.props.lang]} </h2>
                                                <div className='heading-weA' dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[1]?.item[0] && this.state.pageData.section[1].item[0], 'shortDescription', this.props.lang) }}></div>
                                                <p className='para-weassist' dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[1], 'shortDescription', this.props.lang) }}></p>
                                                {this.state.pageData?.section?.[1]?.item?.[0]?.clientText?.[this.props.lang]?.trim?.() ?
                                                    <div className='client-about'>
                                                        {this.state.pageData?.section[1]?.item[0]?.clinicLogo ?
                                                            <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[0] && this.state.pageData.section[1].item[0].clinicLogo)} className="logo-clinic" alt={(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[0] && this.state.pageData.section[1].item[0].clinicLogo?.replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4))} /> : null}

                                                        <h4 className='client-text'>{this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0]?.clientText?.[this.props.lang]} </h4>
                                                        <p className='client-name'>{this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0]?.clientName?.[this.props.lang]} </p>
                                                        <p className='client-position'>{this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[0]?.clientPosition?.[this.props.lang]} </p>
                                                    </div> : null}
                                                {/* {this.state.pageData?.section[1]?.item[1]?.clientText ? 
                                        <div className='client-about-right-mob'>
                                            {this.state.pageData?.section[1]?.item[1]?.clinicLogo ?  
                                            <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].clinicLogo)} className="logo-clinic" alt={(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].clinicLogo?.replace('/uploads/', '').replace('_', ' ').slice(0, -4))}/> : null}
                                           
                                            <h4 className='client-text'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientText?.[this.props.lang]} </h4>
                                            <p className='client-name'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientName?.[this.props.lang]} </p>
                                            <p className='client-position'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientPosition?.[this.props.lang]} </p>
                                        </div> : null} */}

                                            </div>
                                            <div className="col-curoflow-lg-6">


                                                <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].image[this.props.lang])} className={` ${this.state.pageData?.section[1]?.item[1]?.clinicLogo ? 'img-margin' : 'imgNoMrgn'}`} alt={this.state.pageData && this.state.pageData.section && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].image[this.props.lang]?.replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4)} />


                                                <p className='para-weassistNoMob' dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item[1], 'shortDescription', this.props.lang) }}></p>
                                                {/* {this.state.pageData?.section[1]?.item[1]?.clientText ? 
                                        <div className='client-about-right'>
                                            {this.state.pageData?.section[1]?.item[1]?.clinicLogo ?  
                                            <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].clinicLogo)} className="logo-clinic" alt={(this.state.pageData && this.state.pageData.section[1] && this.state.pageData.section[1].item && this.state.pageData.section[1].item[1] && this.state.pageData.section[1].item[1].clinicLogo?.replace('/uploads/', '').replace('_', ' ').slice(0, -4))}/> : null}
                                           
                                            <h4 className='client-text'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientText?.[this.props.lang]} </h4>
                                            <p className='client-name'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientName?.[this.props.lang]} </p>
                                            <p className='client-position'>{this.state.pageData && this.state.pageData.section[1]  && this.state.pageData.section[1].item[1]?.clientPosition?.[this.props.lang]} </p>
                                        </div> : null} */}


                                            </div>
                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section3 ?
                                    <section className={`${(this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0] && this.state.pageData.section[2].item[0].backgroundDark) ? 'curoflow-bg-dark1 curoflow-section-box ' : "no-padding curoflow-section"}`}>
                                        <div className="container-curoflow">
                                            <div className="col-curoflow-lg-6 ">
                                                <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0] && this.state.pageData.section[2].item[0].image?.[this.props.lang])} className="border-img" alt={(this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0] && this.state.pageData.section[2].item[0].image?.[this.props.lang]?.replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4))} />
                                                {this.state.pageData?.section[2]?.item[0]?.clientText ? <div className='client-about'>
                                                    {this.state.pageData?.section[2]?.item[0]?.clinicLogo ? <Img src={API_ENDPOINT + this.state.pageData.section[2].item[0].clinicLogo} alt={(this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0] && this.state.pageData.section[2].item[0].clinicLogo?.replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4))} /> : null}

                                                    <h4 className='client-text'>{this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0]?.clientText?.[this.props.lang]} </h4>
                                                    <p className='client-name'>{this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0]?.clientName?.[this.props.lang]} </p>
                                                    <p className='client-position'>{this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[0]?.clientPosition?.[this.props.lang]} </p>
                                                </div> : null}
                                            </div>
                                            <div className="col-curoflow-lg-6">
                                                <h2>{this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[1]?.title[this.props.lang]} </h2>
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[2] && this.state.pageData.section[2].item[1], 'shortDescription', this.props.lang) }}></p>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section4 ?
                                    <section className='curoflow-section curoflow-margin-top'>
                                        <div className="container-curoflow">
                                            <div className="col-curoflow-lg-6 ">
                                                <h2>{this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[0]?.title[this.props.lang]} </h2>
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[0], 'shortDescription', this.props.lang) }}></p>
                                            </div>
                                            <div className="col-curoflow-lg-6">
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[1], 'shortDescription', this.props.lang) }}></p>

                                                {this.state.pageData?.section[3]?.item[3]?.clientText ? <div className='client-about'>
                                                    {this.state.pageData?.section[3]?.item[2]?.clinicLogo ? <Img src={API_ENDPOINT + this.state.pageData.section[3].item[2].clinicLogo} alt={(this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[2] && this.state.pageData.section[3].item[2].clinicLogo?.replace('/uploads/', '').replace('_', ' ').slice(0, -4))} /> : null}

                                                    <h4 className='client-text'>{this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[3]?.clientText?.[this.props.lang]} </h4>
                                                    <p className='client-name'>{this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[4]?.clientName?.[this.props.lang]} </p>
                                                    <p className='client-position'>{this.state.pageData && this.state.pageData.section[3] && this.state.pageData.section[3].item[5]?.clientPosition?.[this.props.lang]} </p>
                                                </div> : null}
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section5 ?
                                    <section className='curoflow-section curoflow-margin-top'>
                                        <div className="container-curoflow">
                                            <div className="col-curoflow-lg-6 ">

                                                <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[4] && this.state.pageData.section[4].item[1] && this.state.pageData.section[4].item[1].image)} className="border-img" alt={(this.state.pageData && this.state.pageData.section[4] && this.state.pageData.section[4].item[1] && this.state.pageData.section[4].item[1].image?.replace('/uploads/', '').replace('_', ' ').slice(0, -4))} />
                                            </div>
                                            <div className="col-curoflow-lg-6">
                                                <h2>{this.state.pageData && this.state.pageData.section[4] && this.state.pageData.section[4].item[1]?.title[this.props.lang]} </h2>
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[4]?.item[1] && this.state.pageData.section[4].item[1], 'shortDescription', this.props.lang) }}></p>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section6 ?
                                    <div>

                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section7 ?
                                    <section className="no-padding curoflow-section">
                                        <div className="container-curoflow">
                                            <div className="col-curoflow-lg-6 ">
                                                <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[6] && this.state.pageData.section[6].item[0] && this.state.pageData.section[6].item[0].image?.[this.props.lang])} className="border-img" alt={(this.state.pageData && this.state.pageData.section[6] && this.state.pageData.section[6].item[0] && this.state.pageData.section[6].item[0].image?.[this.props.lang].replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4))} />
                                            </div>
                                            <div className="col-curoflow-lg-6">
                                                <h2>{this.state.pageData && this.state.pageData.section[6] && this.state.pageData.section[6].item[1]?.title[this.props.lang]} </h2>
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[6] && this.state.pageData.section[6].item[1], 'shortDescription', this.props.lang) }}></p>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                (this.state.pageData.section8 && !this.state.pageData?.section[7]?.item[1]?.sweeden) || (this.state.pageData.section8 && this.state.pageData?.section[7]?.item[1]?.sweeden && this.props.lang === 'se') ?
                                    <section className="no-padding curoflow-section curoflow-top ">
                                        <div className="container-curoflow column-reverse">
                                            <div className="col-curoflow-lg-6">
                                                <h2>{this.state.pageData && this.state.pageData.section[7] && this.state.pageData.section[7].item[1]?.title[this.props.lang]} </h2>
                                                <p dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[7] && this.state.pageData.section[7].item[1], 'shortDescription', this.props.lang) }}></p>
                                            </div>
                                            <div className="col-curoflow-lg-6 ">
                                                <Img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[7] && this.state.pageData.section[7].item[0] && this.state.pageData.section[7].item[0].image)} className="border-img" alt={(this.state.pageData && this.state.pageData.section[7] && this.state.pageData.section[7].item[0] && this.state.pageData.section[7].item[0].image?.replace('/uploads/', '').replace(/_/g, ' ').slice(0, -4))} />
                                            </div>

                                        </div>
                                    </section>
                                    :
                                    null
                            }
                            {
                                this.state.pageData.section9 ?
                                    <section className='section-curoflow section-curoflow-img new-section-about sectionWeAssist1'>
                                        <div>
                                            <div className='section-curoflow-content'>

                                                <h1 className='go-flow-head'>{this.state.pageData && this.state.pageData.section["8"]?.title[this.props.lang]}</h1>
                                                <div dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section["8"], 'shortDescription', this.props.lang) }}></div>
                                                {this.state.pageData && this.state.pageData.section[8]?.demo ?
                                                    <button className='home-btn-h1' onClick={() => {
                                                        this.setState({
                                                            supportForm11: true
                                                        })
                                                    }}>{'Book a demo'.translate(this.props.lang)}
                                                    </button> : null}
                                                {/* {this.state.pageData && this.state.pageData.section[0]?.video ?
                                                    <button className='home-btn-h1' onClick={() => {
                                                        this.setState({
                                                            playVideo: true,
                                                            playVideoClicks: (this.state.playVideoClicks || 0) + 1
                                                        }, () => {
                                                            if (typeof window !== 'undefined') {
                                                                window.dataLayer = window.dataLayer || [];
                                                                function gtag() { dataLayer.push(arguments); }
                                                      
                                                                gtag('event', 'play_video_button_click_weCare_page', {
                                                                    value: this.state.playVideoClicks,
                                                                    userId: getUserId(),
                                                             

                                                                })
                                                            }
                                                        })
                                                    }}>{'Play video'.translate(this.props.lang)}
                                                    </button> : null}
                                                {this.state.pageData && this.state.pageData.section[0]?.contact ?
                                                    <Link lang={this.props.lang} to="/kontakta-oss" className='home-btn-h1'> {"Contact us".translate(this.props.lang)}</Link> : null} */}
                                            </div>
                                        </div>

                                        <div className='new-img'>
                                            <img className="desktop-img" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section["8"] && this.state.pageData.section["8"].bigImage?.[this.props.lang])} alt={
                                                (this.state.pageData &&
                                                    this.state.pageData.section["8"] &&
                                                    this.state.pageData.section["8"].alt &&
                                                    this.state.pageData.section["8"].alt[this.props.lang])} />


                                            <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[8] && this.state.pageData.section["8"].mobImage?.[this.props.lang])} className='mob-img' alt={
                                                (this.state.pageData &&
                                                    this.state.pageData.section["8"] &&
                                                    this.state.pageData.section["8"].alt &&
                                                    this.state.pageData.section["8"].alt[this.props.lang])} />

                                        </div>

                                    </section>
                                    :
                                    null
                            }

                            {
                                this.state.pageData.section10 ?
                                    <section className='sectionWeAssist2'>




                                        {this.state.pageData && this.state.pageData.section["9"]?.women ?

                                            <>
                                                <div className='container-curoflow container-curoflow-logos woman'>


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo1 &&
                                                            this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo2 &&
                                                            this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo3 &&
                                                            this.state.pageData.section[9].altLogo3[this.props.lang])} />

                                                </div>


                                                <section className='logo-slider woman-slider'>
                                                    <Marquee speed={70} pauseOnClick={true}>

                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo1 &&
                                                                this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo2 &&
                                                                this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo3 &&
                                                                this.state.pageData.section[9].altLogo3[this.props.lang])} />



                                                    </Marquee>
                                                </section>

                                            </>
                                            : null}


                                        {this.state.pageData && this.state.pageData.section["9"]?.weight ?
                                            <>
                                                <div className='container-curoflow container-curoflow-logos weight'>

                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo1 &&
                                                            this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo2 &&
                                                            this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo3 &&
                                                            this.state.pageData.section[9].altLogo3[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo4)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo4 &&
                                                            this.state.pageData.section[9].altLogo4[this.props.lang])} />




                                                </div>


                                                <section className='logo-slider weight-slider'>
                                                    <Marquee speed={70} pauseOnClick={true}>

                                                        <img className="logo-women1" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo1 &&
                                                                this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                        <img className="logo-women2" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo2 &&
                                                                this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                        <img className="logo-women3" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo3 &&
                                                                this.state.pageData.section[9].altLogo3[this.props.lang])} />


                                                        <img className="logo-women3" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo4)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo4 &&
                                                                this.state.pageData.section[9].altLogo4[this.props.lang])} />
                                                    </Marquee>
                                                </section>








                                            </> : null}



                                        {this.state.pageData && this.state.pageData.section["9"]?.psycho ?
                                            <>
                                                <div className='container-curoflow container-curoflow-logos pysho'>

                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo1 &&
                                                            this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo2 &&
                                                            this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo3 &&
                                                            this.state.pageData.section[9].altLogo3[this.props.lang])} />

                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo4)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo4 &&
                                                            this.state.pageData.section[9].altLogo4[this.props.lang])} />

                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo5)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo5 &&
                                                            this.state.pageData.section[9].altLogo5[this.props.lang])} />

                                                    <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo6)} alt={
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[9] &&
                                                            this.state.pageData.section[9].altLogo6 &&
                                                            this.state.pageData.section[9].altLogo6[this.props.lang])} />




                                                </div>

                                                <section className='logo-slider psyho-slider'>
                                                    <Marquee speed={70} pauseOnClick={true}>

                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo1)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo1 &&
                                                                this.state.pageData.section[9].altLogo1[this.props.lang])} />


                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo2)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo2 &&
                                                                this.state.pageData.section[9].altLogo2[this.props.lang])} />


                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo3)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo3 &&
                                                                this.state.pageData.section[9].altLogo3[this.props.lang])} />

                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo4)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo4 &&
                                                                this.state.pageData.section[9].altLogo4[this.props.lang])} />

                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo5)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo5 &&
                                                                this.state.pageData.section[9].altLogo5[this.props.lang])} />

                                                        <img className="logo-women" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[9] && this.state.pageData.section[9].logo6)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[9] &&
                                                                this.state.pageData.section[9].altLogo6 &&
                                                                this.state.pageData.section[9].altLogo6[this.props.lang])} />
                                                    </Marquee>
                                                </section>



                                            </> : null}









                                    </section>

                                    : null}

                            {this.state.pageData.section11 ? (
                                <section className="curoflow-section-info sectionWeAssist3">
                                    <div className="container-curoflow white-6-title">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[10] &&
                                                this.state.pageData.section[10].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[10] &&
                                                    this.state.pageData.section[10],
                                                    "subtitle",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>

                                    </div>
                                    <div className="container-curoflow">
                                        <div className="col-curoflow-lg-4 bg-white">
                                            <div className="info-box">
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10].image1)
                                                    }
                                                />
                                                <h4 className="black-title">
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[10] &&
                                                        this.state.pageData.section[10].title1[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h4>
                                                <div
                                                    className="black-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10],
                                                            "shortDescription1",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>
                                        </div>

                                        <div className="col-curoflow-lg-4 bg-white">
                                            <div className="info-box">
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10].image2)
                                                    }
                                                />
                                                <h4 className="black-title">
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[10] &&
                                                        this.state.pageData.section[10].title2[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h4>
                                                <div
                                                    className="black-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10],
                                                            "shortDescription2",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        <div className="col-curoflow-lg-4 bg-white">
                                            <div className="info-box">
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10].image3)
                                                    }
                                                />
                                                <h4 className="black-title">
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[10] &&
                                                        this.state.pageData.section[10].title3[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h4>
                                                <div
                                                    className="black-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[10] &&
                                                            this.state.pageData.section[10],
                                                            "shortDescription3",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            ) : null}

                            {this.state.pageData.section12 ? (
                                <section className="curoflow-section-info sectionWeAssist4">

                                    <div className="container-curoflow">
                                        <div className="col-curoflow-lg-6">

                                            <h2 className=''>{this.state.pageData && this.state.pageData.section[11]?.title[this.props.lang]}</h2>
                                            <div dangerouslySetInnerHTML={{ __html: Object.translate(this.state.pageData && this.state.pageData.section[11], 'subtitle', this.props.lang) }}></div>
                                        </div>

                                        <div className="col-curoflow-lg-6">
                                            <img className="logo-women1" src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[11] && this.state.pageData.section[11].image[this.props.lang])} alt={
                                                (this.state.pageData &&
                                                    this.state.pageData.section[11] &&
                                                    this.state.pageData.section[11].alt &&
                                                    this.state.pageData.section[11].alt[this.props.lang])} />

                                        </div>
                                    </div>
                                </section>
                            ) : null}

                            {this.state.pageData.section13 ? (
                                <section className="sectionWeAssist5">
                                    <div className="container-curoflow white-6-title">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[12] &&
                                                this.state.pageData.section[12].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[12] &&
                                                    this.state.pageData.section[12],
                                                    "subtitle",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>

                                    </div>
                                    <div className="sectionWeAssistContent5">
                                        <div className="sectionWeAssistContentBox">
                                            <div className='svg-image'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12].image1)
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <h5>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[12] &&
                                                        this.state.pageData.section[12].title1[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h5>
                                                <div

                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12],
                                                            "shortDescription1",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>


                                        </div>

                                        <div className="sectionWeAssistContentBox">
                                            <div className='svg-image'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12].image2)
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <h5>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[12] &&
                                                        this.state.pageData.section[12].title2[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h5>
                                                <div

                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12],
                                                            "shortDescription2",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>


                                        </div>

                                        <div className="sectionWeAssistContentBox">
                                            <div className='svg-image'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12].image3)
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <h5>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[12] &&
                                                        this.state.pageData.section[12].title3[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h5>
                                                <div

                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12],
                                                            "shortDescription3",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>


                                        </div>

                                        <div className="sectionWeAssistContentBox">
                                            <div className='svg-image'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12].image4)
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <h5>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[12] &&
                                                        this.state.pageData.section[12].title4[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h5>
                                                <div

                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12],
                                                            "shortDescription4",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>


                                        </div>

                                        <div className="sectionWeAssistContentBox">
                                            <div className='svg-image'>


                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12].image5)
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <h5>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[12] &&
                                                        this.state.pageData.section[12].title5[
                                                        this.props.lang
                                                        ]}{" "}
                                                </h5>
                                                <div

                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[12] &&
                                                            this.state.pageData.section[12],
                                                            "shortDescription5",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>


                                        </div>







                                    </div>
                                </section>
                            ) : null}

                            {this.state.pageData.section14 ? (
                                <section className='sectionWeAssist6'>


                                    <div className="container-curoflow sectionWeAssistContainer6">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[13] &&
                                                this.state.pageData.section[13].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[13] &&
                                                    this.state.pageData.section[13],
                                                    "subtitle",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>
                                        <button onClick={() => {

                                            if (this.props.lang === 'en') {
                                                this.props[0].history.push('/en/customer-feedback-on-Curoflow-telemedicine-platform')
                                                return;
                                            }



                                            this.props[0].history.push('/kunders-feedback-pa-Curoflow-digital-vardplattform')
                                        }} className='customerBtn121'>{"Läs fler kundberättelser".translate(this.props.lang)}</button>

                                    </div>


                                    {this.state.pageData && !this.state.pageData.section[13]?.showSlider ?

                                        <div className="container-curoflow sectionWeAssistContainer66">
                                            <div className="col-curoflow-lg-6 image-weAssist">
                                                <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].image[this.props.lang])} alt={
                                                    (this.state.pageData &&
                                                        this.state.pageData.section[13] &&
                                                        this.state.pageData.section[13].alt &&
                                                        this.state.pageData.section[13].alt[this.props.lang])} />
                                            </div>

                                            <div className="col-curoflow-lg-6 sectionWeAssistContainer666">
                                                <img className='logoWeAssit6' src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].imageLogo)} alt={
                                                    (this.state.pageData &&
                                                        this.state.pageData.section[13] &&
                                                        this.state.pageData.section[13].logoAlt &&
                                                        this.state.pageData.section[13].logoAlt[this.props.lang])} />
                                                <div className=""
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[13] &&
                                                            this.state.pageData.section[13],
                                                            "shortDescription",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>

                                        </div> : null}

                                    {this.state.pageData && this.state.pageData.section[13]?.showSlider ?
                                        <div className='sliderWeAssit home7'>

                                            <Slider  {...{
                                                dots: true,
                                                infinite: true,
                                                speed: 1500,
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                autoplaySpeed: 8000,
                                                swipe: false,
                                                responsive: [
                                                    {
                                                        breakpoint: 576,
                                                        settings: {
                                                            swipe: true,
                                                            dots: true
                                                        },
                                                    }
                                                ]
                                            }}>

                                                <div className='content-slider7'>

                                                    <div className='main-img-slider-content'>
                                                        <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].image[this.props.lang])} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[13] &&
                                                                this.state.pageData.section[13].alt &&
                                                                this.state.pageData.section[13].alt[this.props.lang])} className='main-img-slider' />
                                                    </div>

                                                    <div className='content-slider2'>
                                                        <img className='main-logo-slider' src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].imageLogo)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[13] &&
                                                                this.state.pageData.section[13].logoAlt &&
                                                                this.state.pageData.section[13].logoAlt[this.props.lang])} />
                                                        <div className='subtitle-slider'
                                                            dangerouslySetInnerHTML={{
                                                                __html: Object.translate(
                                                                    this.state.pageData &&
                                                                    this.state.pageData.section[13],
                                                                    "shortDescription",
                                                                    this.props.lang
                                                                ),
                                                            }}
                                                        ></div>
                                                    </div>



                                                </div>
                                                <div className='content-slider7'>

                                                    <div className='main-img-slider-content'>
                                                        <img src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].image1[this.props.lang])} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[13] &&
                                                                this.state.pageData.section[13].alt1 &&
                                                                this.state.pageData.section[13].alt1[this.props.lang])} className='main-img-slider' />
                                                    </div>

                                                    <div className='content-slider2'>
                                                        <img className='main-logo-slider' src={API_ENDPOINT + (this.state.pageData && this.state.pageData.section[13] && this.state.pageData.section[13].imageLogo1)} alt={
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[13] &&
                                                                this.state.pageData.section[13].logoAl1t &&
                                                                this.state.pageData.section[13].logoAlt1[this.props.lang])} />
                                                        <div className='subtitle-slider'
                                                            dangerouslySetInnerHTML={{
                                                                __html: Object.translate(
                                                                    this.state.pageData &&
                                                                    this.state.pageData.section[13],
                                                                    "shortDescription1",
                                                                    this.props.lang
                                                                ),
                                                            }}
                                                        ></div>
                                                    </div>



                                                </div>

                                            </Slider>

                                        </div> : null}




                                </section>
                            ) : null}

                            {this.state.pageData.section15 ? (
                                <section className='sectionWeAssist7'>


                                    <div className="container-curoflow sectionWeAssistContainer7">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[14] &&
                                                this.state.pageData.section[14].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[14] &&
                                                    this.state.pageData.section[14],
                                                    "subtitle",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>

                                    </div>

                                    <Waypoint onEnter={() => {
                                        if (!this.waypointCBAlreadyCalled) {
                                            this.waypointCBAlreadyCalled = true;

                                            this.increment()
                                            this.increment1()
                                            this.increment2();


                                        } else return;
                                    }}>

                                        <div style={{ height: 10, visibility: 'hidden' }} />

                                    </Waypoint>
                                    {/* : null } */}


                                    <div className='sectionWeAssistContent7'>


                                        <div className='sectionWeAssistContentBox7'>

                                            <h1>{this.state._first}h</h1>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[14] &&
                                                        this.state.pageData.section[14],
                                                        "shortDescription1",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>


                                        </div>



                                        <div className='sectionWeAssistContentBox7'><h1>{this.state._second} %</h1>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[14] &&
                                                        this.state.pageData.section[14],
                                                        "shortDescription2",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>


                                        </div>



                                        <div className='sectionWeAssistContentBox7'><h1>{this.state._third} %</h1>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[14] &&
                                                        this.state.pageData.section[14],
                                                        "shortDescription3",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>


                                        </div>
                                    </div>



                                </section>
                            ) : null}

                            {this.state.pageData.section16 ? (
                                <section className='sectionWeAssist8'>


                                    <div className="container-curoflow sectionWeAssistContainer8">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[15] &&
                                                this.state.pageData.section[15].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[15] &&
                                                    this.state.pageData.section[15],
                                                    "subtitle",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>

                                    </div>

                                    {/* <Waypoint onEnter={() => {
                                        if (!this.waypointCBAlreadyCalled) {
                                            this.waypointCBAlreadyCalled = true;

                                            this.increment()
                                            this.increment1()
                                            this.increment2();


                                        } else return;
                                    }}>

                                        <div style={{ height: 10, visibility: 'hidden' }} />

                                    </Waypoint> */}

                                    {this.state.pageData && !this.state.pageData.section[15]?.allSections ?

                                        <div className='container-curoflow'>
                                            <div className='col-curoflow-lg-6 sectionWeAssistContent8'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT + 
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15].image1)
                                                    }
                                                />
                                                <h4>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[15] &&
                                                        this.state.pageData.section[15].title1[
                                                        this.props.lang
                                                        ]}
                                                </h4>
                                                <div className="sectionWeAssistContentText8"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15],
                                                            "shortDescription1",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>


                                                <button className='home-btn-h1' onClick={() => {
                                                    this.setState({
                                                        supportForm12: true
                                                    })
                                                }}>{'Book a demo'.translate(this.props.lang)}
                                                </button>


                                            </div>
                                            <div className='col-curoflow-lg-6 sectionWeAssistContent8'>
                                                <Isvg
                                                    src={
                                                        API_ENDPOINT +
                                                        (this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15].image2)
                                                    }
                                                />
                                                <h4>
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[15] &&
                                                        this.state.pageData.section[15].title2[
                                                        this.props.lang
                                                        ]}
                                                </h4>
                                                <div className="sectionWeAssistContentText8"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15],
                                                            "shortDescription2",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>

                                                <button className='home-btn-h1 btnWeAssist2' onClick={() => {
                                                    this.setState({
                                                        supportForm13: true
                                                    })
                                                }}>{'Book a demo'.translate(this.props.lang)}
                                                </button>

                                            </div>

                                        </div> : null}


                                    {this.state.pageData && this.state.pageData.section[15]?.allSections ?
                                        <div className='allSectionsPackages'>
                                            <div className='container-curoflow'>


                                                <div className='col-curoflow-lg-4 sectionWeAssistContent8'>
                                                    <Isvg
                                                        src={
                                                            API_ENDPOINT +
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15].image1)
                                                        }
                                                    />
                                                    <h4>
                                                        {this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15].title1[
                                                            this.props.lang
                                                            ]}
                                                    </h4>
                                                    <div className="sectionWeAssistContentText8"
                                                        dangerouslySetInnerHTML={{
                                                            __html: Object.translate(
                                                                this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15],
                                                                "shortDescription1",
                                                                this.props.lang
                                                            ),
                                                        }}
                                                    ></div>


                                                </div>
                                                <div className='col-curoflow-lg-4 sectionWeAssistContent8'>
                                                    <Isvg
                                                        src={
                                                            API_ENDPOINT +
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15].image2)
                                                        }
                                                    />
                                                    <h4>
                                                        {this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15].title2[
                                                            this.props.lang
                                                            ]}
                                                    </h4>
                                                    <div className="sectionWeAssistContentText8"
                                                        dangerouslySetInnerHTML={{
                                                            __html: Object.translate(
                                                                this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15],
                                                                "shortDescription2",
                                                                this.props.lang
                                                            ),
                                                        }}
                                                    ></div>
                                                </div>
                                                <div className='col-curoflow-lg-4 sectionWeAssistContent8'>
                                                    <Isvg
                                                        src={
                                                            API_ENDPOINT +
                                                            (this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15].image3)
                                                        }
                                                    />
                                                    <h4>
                                                        {this.state.pageData &&
                                                            this.state.pageData.section[15] &&
                                                            this.state.pageData.section[15].title3[
                                                            this.props.lang
                                                            ]}
                                                    </h4>
                                                    <div className="sectionWeAssistContentText8"
                                                        dangerouslySetInnerHTML={{
                                                            __html: Object.translate(
                                                                this.state.pageData &&
                                                                this.state.pageData.section[15] &&
                                                                this.state.pageData.section[15],
                                                                "shortDescription3",
                                                                this.props.lang
                                                            ),
                                                        }}
                                                    ></div>
                                                </div>

                                            </div>
                                            <button className='home-btn-h1' onClick={() => {
                                                this.setState({
                                                    supportForm13: true
                                                })
                                            }}>{'Book a demo'.translate(this.props.lang)}
                                            </button>
                                        </div>

                                        : null}


                                </section>
                            ) : null}


                            {this.state.pageData.section17 ? (

                                <section className="white-6">
                                    <img src={AppImg} className='AppImg' />
                                    <div className="container-curoflow white-6-title">
                                        <h2>
                                            {this.state.pageData &&
                                                this.state.pageData.section[16] &&
                                                this.state.pageData.section[16].title[
                                                this.props.lang
                                                ]}
                                        </h2>
                                        <div className="last-white-section"
                                            dangerouslySetInnerHTML={{
                                                __html: Object.translate(
                                                    this.state.pageData &&
                                                    this.state.pageData.section[16],
                                                    "shortDescription",
                                                    this.props.lang
                                                ),
                                            }}
                                        ></div>

                                    </div>
                                    <div className="container-curoflow white-6-content">

                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title1[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription1",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>

                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title2[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription2",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className="container-curoflow white-6-content">

                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title3[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription3",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>
                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title4[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription4",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>

                                    </div>
                                    <div className="container-curoflow white-6-content">

                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title5[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription5",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>

                                        <div className="col-curoflow-lg-6 box-content">
                                            <h5 className="bg-title-yellow">
                                                {this.state.pageData &&
                                                    this.state.pageData.section[16] &&
                                                    this.state.pageData.section[16].title6[
                                                    this.props.lang
                                                    ]}
                                            </h5>
                                            <div
                                                className="bg-title-white"
                                                dangerouslySetInnerHTML={{
                                                    __html: Object.translate(
                                                        this.state.pageData &&
                                                        this.state.pageData.section[16],
                                                        "shortDescription6",
                                                        this.props.lang
                                                    ),
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                    {this.state.pageData && this.state.pageData.section[16]?.allSections ?
                                        <div className="container-curoflow white-6-content">

                                            <div className="col-curoflow-lg-6 box-content">
                                                <h5 className="bg-title-yellow">
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[16] &&
                                                        this.state.pageData.section[16].title7[
                                                        this.props.lang
                                                        ]}
                                                </h5>
                                                <div
                                                    className="bg-title-white"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[16],
                                                            "shortDescription7",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>

                                            <div className="col-curoflow-lg-6 box-content">
                                                <h5 className="bg-title-yellow">
                                                    {this.state.pageData &&
                                                        this.state.pageData.section[16] &&
                                                        this.state.pageData.section[16].title8[
                                                        this.props.lang
                                                        ]}
                                                </h5>
                                                <div
                                                    className="bg-title-white"
                                                    dangerouslySetInnerHTML={{
                                                        __html: Object.translate(
                                                            this.state.pageData &&
                                                            this.state.pageData.section[16],
                                                            "shortDescription8",
                                                            this.props.lang
                                                        ),
                                                    }}
                                                ></div>
                                            </div>
                                        </div> : null}


                                </section>

                            ) : null}

                            <ContactForm title={this.state.pageData && this.state.pageData.section[5] && this.state.pageData.section[5].item[0]?.title[this.props.lang]} text={this.state.pageData && this.state.pageData.section[5] && this.state.pageData.section[5].item[0] ? Object.translate(this.state.pageData && this.state.pageData.section[5] && this.state.pageData.section[5].item[0], 'shortDescription', this.props.lang) : null} contactFormError={this.state.contactFormError} class={'grey'} onSubmit={this.sendMessage2} lang={this.props.lang} contactFormMessageError={this.state.contactFormMessageError} />
                        </div>
                        :
                        null
                }

            </div>
        );
    }
}

export default Page(WeAssist);

